(() => {
  if (customElements.get('cart-upsell-slider')) {
    return;
  }

  class CartUpsellSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        slidesPerView: 1.5,
        spaceBetween: 16,
        navigation: {
          prevEl: this.closest('[data-cart-drawer-upsell]').querySelector(
            '[data-arrow-prev]',
          ),
          nextEl: this.closest('[data-cart-drawer-upsell]').querySelector(
            '[data-arrow-next]',
          ),
        },
      };

      if (this.dataset.drawer) {
        this.options.slidesPerView = 1.5;
      } else {
        this.options['breakpoints'] = {
          768: {
            slidesPerView: 4,
          },
        };
      }
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(this, this.options);
    }
  }

  customElements.define('cart-upsell-slider', CartUpsellSlider);
})();
